import { jwtDecode } from "jwt-decode";

export const isTokenValid = (token: string | null) => {
  try {
    if (!token || typeof token !== "string") return false;

    const decoded = jwtDecode(token);

    if (!decoded.exp) return false;
    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    console.error("Invalid token format:", error);
    return false;
  }
};
